// Interfaces
import { IBaseImageProps, IBaseImageRenderImageAttrs, IBaseImageRenderStyleAttrs } from './interfaces'

const BaseImage = ({ isIcon, isImage, image, icon, width, height, format, isSvg, isGif, isError, onClick }: IBaseImageProps) => {
  /**
   * @description Render svg or any other image
   *
   * @param {boolean} isIcon
   * @param {boolean} isImage
   * @param {boolean} isSvg
   * @param {string} format
   *
   * @return {any} any
   */
  const renderImage = ({ isIcon, isImage, isSvg, format }: IBaseImageRenderImageAttrs): any => {
    if (isIcon) return require(`assets/icon/${icon}.${isSvg ? 'svg' : format || 'png'}`).default
    if (isImage) return require(`assets/images/${image}.${isSvg ? 'svg' : isGif ? 'gif' : format || 'png'}`).default

    // Render URL
    return image || icon
  }

  /**
   * @description Render image style
   *
   * @param {string} width
   * @param {string} height
   *
   * @return {object} object
   */
  const renderStyle = ({ width, height }: IBaseImageRenderStyleAttrs): any => {
    return { width, height, objectFit: 'cover', float: 'none' }
  }

  const errorStyles = {
    borderColor: '#ff5858',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '8px',
  }

  return (
    <img
      src={renderImage({ isIcon, isImage, isSvg, format })}
      alt={image || icon}
      style={{ ...renderStyle({ width, height }), ...(isError ? errorStyles : {}) }}
      onClick={onClick}
    />
  )
}

export { BaseImage }
